<template>
    <div id="postacell-detail">
        <div class="header">
            <div class="title">{{ $t("message.details") }}</div>
            <div class="subtitle">{{ $t("message.manageChannelDetail") }}</div>
        </div>
        <div id="new-sms-channel-form">
            <a-form>
                <div class="form-wrapper">
                    <div class="input-wrapper">
                        <label>{{ $t("whatsappChannel.channelName") }}</label>
                        <a-form-item :validate-status="getErrorStatus('name')" :help="getErrorMessage('name')">
                            <a-input
                                v-model="clone.name"
                                :placeholder="$t('whatsappChannel.channelName')"
                                name="name"
                                ref="name"
                            />
                        </a-form-item>
                    </div>
                    <div class="input-wrapper">
                        <label>Username</label>
                        <a-input
                            placeholder="Username"
                            v-model="clone.payload.username"
                            v-validate="'required'"
                            name="username"
                        />
                    </div>
                    <div class="input-wrapper">
                        <label>Password </label>
                        <a-input
                            placeholder="Password"
                            v-model="clone.payload.password"
                            v-validate="'required'"
                            name="password"
                        />
                    </div>
                    <div class="input-wrapper">
                        <label>Your Credit </label>
                        <a-input
                            :value="credit"
                            disabled
                        />
                    </div>
                </div>
            </a-form>

            <div class="form-footer">
                <div class="actions">
                    <a-button class="pr-confirm-btn" @click="handleSave" type="primary" :disabled="loading">
                        {{ $t("message.save") }}</a-button
                    >
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import _ from "lodash";

export default {
    name: "UpdateChannelDetails",
    props: {
        value: {
            type: Object,
            required: true,
        },
        credit: {
            type: Number,
            default: 0
        },
    },
    components: {},
    data() {
        return {
            showStories: false,
            alldepartments: [],
            loading: false,
            clone: _.cloneDeep(this.value),
            submitClicked: false,
        };
    },
    computed: {
        ...mapState({
            stories: (state) => state.CB.stories,
            subjects: (state) => _.get(state.subject.subjects, "data", []) || [],
        }),
    },
    methods: {
        ...mapActions({
            createChannel: "channel/createChannel",
            updateChannel: "channel/updateChannel",
        }),
        getErrorStatus(fieldName) {
            return this.clone[fieldName].length < 1 && this.submitClicked ? "error" : "";
        },
        getErrorMessage(fieldName) {
            return this.clone[fieldName].length < 1 && this.submitClicked ? this.$t("message.requiredChannel") : "";
        },
        getSubjectTitle(department) {
            const validLangs = Object.keys(department.languageContent);
            const targetLang = validLangs.includes(this.$i18n.locale) ? this.$i18n.locale : validLangs[0];
            const key = `languageContent.${targetLang}.name`;
            return _.get(department, key);
        },
        handleSave() {
            this.submitClicked = true;
            if (this.clone.name.length < 1) {
                this.$refs.name.focus();
                return;
            } else {
                const isValid = true;
                if (isValid) {
                    this.loading = true;
                    this.updateChannel(this.clone)
                        .then(() => {
                            this.$message.success("Kanal Güncellendi");
                            this.$emit("ok");
                        })
                        .catch((err) => {
                            this.$message.error("Kanal Güncellenemedi");
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                }
            }
        },
    },
    mounted() {},
    beforeDestroy() {},
    watch: {
        value: {
            handler: function (val) {
                const isChanged = !_.isEqual(val, this.clone);
                if (isChanged) {
                    this.clone = _.cloneDeep(val);
                }
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.header {
    display: flex;
    justify-content: space-between;
    padding-top: 10px;
    padding-bottom: 10px;

    border-bottom: 1px solid var(--color-border-default);

    .title {
        font-size: 18px;
        font-weight: 700;
        color: var(--color-text-strong-default);
        padding-left: 5px;
    }

    .subtitle {
        font-size: 14px;
        color: var(--color-text-strong-default);
    }
}
#new-sms-channel-form {
    min-height: 250px;
    flex-direction: column;

    .form-wrapper {
        padding: 20px;
        display: flex;
        flex-direction: column;
        gap: 10px;

        .input-wrapper {
            display: flex;
            flex-direction: column;
            gap: 5px;
        }
    }

    .form-footer {
        display: flex;
        justify-content: flex-end;
        padding: 10px;
        margin-top: 20px;
        background: var(--color-bg-default);
        border-top: 1px solid var(--color-border-default);
    }
}
</style>
<style lang="scss">
.new-sms-postacell {
    .custom-modal-body {
        padding: 0px !important;
    }
}
</style>
